import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ContractReceipt, ContractTransaction } from 'ethers';
import _ from 'lodash';
import { normalizeTransactionError } from '../transaction-error.ts';

export const REDUCER_NAME = 'Transaction';

let TransactionId = 1;

export interface TransactionModel {
    transactions: TransactionResult[];
    counter: number;
}
/**
 * 添加一个交易记录
 */
export const addTransaction = createAsyncThunk(REDUCER_NAME + '/addTransaction', async (data: TransactionData, api) => {
    const curId = TransactionId;
    TransactionId++;
    api.dispatch(addOne({ data: data.data, type: data.type, id: curId }));
    // 监听结果
    try {
        let contractTransaction: ContractTransaction;
        if (_.isFunction(data.transaction.then)) {
            contractTransaction = await data.transaction;
        } else {
            contractTransaction = data.transaction;
        }
        api.dispatch(onChange({ id: curId, tran: contractTransaction, state: 'Submitted' }));
        const cwait = await contractTransaction.wait();
        api.dispatch(onSuccess({ id: curId, receipt: cwait }));
        if (data.onDone) {
            setTimeout(() => data.onDone && data.onDone(), 2000);
        }
    } catch (e) {
        api.dispatch(onFail({ id: curId, error: normalizeTransactionError(e) }));
    }
});

const transactionSlice = createSlice({
    name: REDUCER_NAME,
    initialState: { transactions: [] as TransactionResult[], counter: 0 } as TransactionModel,
    reducers: {
        addOne: (state, action: PayloadAction<{ id: number; data: any; type: TransactionType }>) => {
            const data = {} as TransactionResult;
            data.state = 'Preparing';
            data.id = action.payload.id;
            data.type = action.payload.type;
            data.data = action.payload.data;
            state.counter = state.counter + 1;
            state.transactions.push(data);
        },
        onChange: (state, action: PayloadAction<{ state: TransactionState; tran?: ContractTransaction; id: number; error?: any }>) => {
            const tran = _.findLast(state.transactions, (o) => o.id == action.payload.id);
            if (!tran) {
                return;
            }
            tran.state = action.payload.state;
            tran.transaction = action.payload.tran;
            tran.error = action.payload.error;
        },
        onFail: (state, action: PayloadAction<{ error?: any; id: number }>) => {
            const tran = _.findLast(state.transactions, (o) => o.id == action.payload.id);
            if (!tran) {
                return;
            }
            tran.state = 'Failed';
            tran.error = action.payload.error;
            state.counter = Math.max(0, state.counter - 1);
        },
        onSuccess: (state, action: PayloadAction<{ receipt: ContractReceipt; id: number }>) => {
            const tran = _.findLast(state.transactions, (o) => o.id == action.payload.id);
            if (!tran) {
                return;
            }
            tran.state = 'Confirmed';
            tran.recipet = action.payload.receipt;
            state.counter = Math.max(0, state.counter - 1);
        },
    },
});
export const { addOne, onChange, onSuccess, onFail } = transactionSlice.actions;
export default transactionSlice.reducer;
